<template>
  <div class="text-sm md:text-base md:text-center">
    <div class="text-xl md:text-3xl lg:text-4xl font-semibold text-blue dark:text-white">
      <slot name="value"/>
    </div>

    <slot/>
  </div>
</template>
